import { Injectable } from '@nestjs/common';
import { VehicleMaster } from '../vehicle-master.entity';
import { VehicleMasterDTO } from './vehicle.dto';

@Injectable()
export class VehicleAdapter {
  /**
   *
   * @param VehicleDto
   * @returns Vehicle entity
   */
  public convertDtoToEntity(  vehicleMasterDTO: VehicleMasterDTO,  isUpdate: boolean = false ): VehicleMaster {
    const vehicle = new VehicleMaster();
    vehicle.vehicleId=vehicleMasterDTO.vehicleId;
    vehicle.registrationNumber=vehicleMasterDTO.registrationNumber;
    vehicle.vehicleName=vehicleMasterDTO.vehicleName;
    vehicle.isActive=vehicleMasterDTO.isActive==undefined?true:vehicleMasterDTO.isActive;
    if (isUpdate) {
      vehicle.updatedUser = vehicleMasterDTO.updatedUser;
    } else {
      vehicle.isActive = true;
      vehicle.createdUser = vehicleMasterDTO.createdUser;
    }
   return vehicle;
  }
  public convertEntityToDto(vehicleObject: VehicleMaster): VehicleMasterDTO {
    const vehicleMasterDTO= new VehicleMasterDTO;
    vehicleMasterDTO.vehicleId = vehicleObject.vehicleId;
    vehicleMasterDTO.registrationNumber = vehicleObject.registrationNumber;
    vehicleMasterDTO.vehicleName = vehicleObject.vehicleName;
    vehicleMasterDTO.isActive = vehicleObject.isActive;
    vehicleMasterDTO.createdAt = vehicleObject.createdAt;
    vehicleMasterDTO.updatedAt = vehicleObject.updatedAt;
    vehicleMasterDTO.createdUser = vehicleObject.createdUser;
    vehicleMasterDTO.updatedUser = vehicleObject.updatedUser;
    vehicleMasterDTO.versionFlag = vehicleObject.versionFlag;
    vehicleMasterDTO.isAvailable = vehicleObject.isAvailable
    return vehicleMasterDTO;
  }
}
